/**
 * Created by JackCui on 2022/9/19
 */
import {batchHandleUrl} from '../../../utils/url-handle.js'

const router = {
  // 获取按钮路由
  getAbility: {
    url: '/apaas/layout/getLookUpRelationInterfaces',
    type: 'POST'
  }
}
export default batchHandleUrl(router)
